import { render, staticRenderFns } from "./toolbar-item.vue?vue&type=template&id=2c44d957&"
import script from "./toolbar-item.vue?vue&type=script&lang=js&"
export * from "./toolbar-item.vue?vue&type=script&lang=js&"
import style0 from "./toolbar-item.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "toolbar-item.vue"
export default component.exports